import React from "react";
import { useTranslation } from "react-i18next";

export default function XTwitterIcon({ className, style, fill = "currentColor", width, height }) {
  const { t } = useTranslation();
  return (
    <svg viewBox="0 0 24 24" fill={fill} className={className} style={style} width={width} height={height} aria-label={t("X (Twitter)")}>
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.253 5.622L18.244 2.25Zm-1.161 17.52h1.833L7.084 4.126H5.117L17.083 19.77Z" />
    </svg>
  );
}
